import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common'; // ➔ 追加
import { MatFormFieldModule } from '@angular/material/form-field'; // ➔ 追加
import { MatInputModule } from '@angular/material/input'; // ➔ 追加
import { MatSelectModule } from '@angular/material/select';
import { PRICING_MODEL, BILLING_FREQUENCY } from 'src/app/constants/app-constants';

@Component({
  selector: 'app-billing-terms-form',
  templateUrl: './billing-terms-form.component.html',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
  ],
})
export class BillingTermsFormComponent {
  // 親（distributor-detail）から billingTerms グループを受け取る
  @Input() billingTermsForm!: FormGroup;

  pricingModel = PRICING_MODEL;
  billingFrequency = BILLING_FREQUENCY;

  static createBillingTermsGroup(): FormGroup {
    return new FormGroup({
      billingFrequency: new FormControl("Monthly", [Validators.required]),
      billingCycleAnchorMonth: new FormControl("0", [Validators.required]),
      billingCycleAnchorDay: new FormControl("31", [Validators.required]),
      paymentTermsMonths: new FormControl("1", [Validators.required]),
      paymentTermsDays: new FormControl("0", [Validators.required]),
      pricingModel: new FormControl("Fixed", [Validators.required]),
      currency: new FormControl("JPY", [Validators.required]),
      basePrice: new FormControl("0", [Validators.required]),
      unitPrice: new FormControl("0", [Validators.required])
    });
  }

}

export interface BillingTerms {
  billingFrequency: string;
  billingCycleAnchorMonth: number;
  billingCycleAnchorDay: number;
  paymentTermsMonths: number;
  paymentTermsDays: number;
  pricingModel: string;
  currency: string;
  basePrice: number;
  unitPrice: number;
}

export const BillingTermsDefaultValue = {
    billingFrequency : "Monthly",
    billingCycleAnchorMonth: 0,
    billingCycleAnchorDay: 31,
    paymentTermsMonths: 1,
    paymentTermsDays: 0,
    pricingModel: "Fixed",
    currency: "JPY",
    basePrice: 0,
    unitPrice: 0
}